const VITE_API_HOST = import.meta.env.VITE_API_HOST || 'https://127.0.0.1';

// @ts-ignore
export default {

	// @ts-ignore
	VERSION: APP_VERSION,

	// @ts-ignore
	RELEASE_NAME: APP_RELEASE_NAME,

	// @ts-ignore
	ENV: import.meta.env.VITE_ENVIRONMENT || 'development',

	// @ts-ignore
	MAINTENANCE_MODE: import.meta.env.VITE_MAINTENANCE_MODE !== 'false',

	// @ts-ignore
	BUILD_TIMESTAMP: new Date(APP_BUILD_TIMESTAMP),

	/**
	 * API URL: location of the
	 * (VITE_SMARTSYMBOLS_API_URL is deprecatd)
	 */
	// @ts-ignore
	API_URL: import.meta.env.VITE_SMARTSYMBOLS_API_URL || (VITE_API_HOST + '/api/v1/'),

	// @ts-ignore
	SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || null,

	// @ts-ignore
	SENTRY_TRACES_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ? parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) : 1.0,

	// @ts-ignore
	GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID || null,

	ORG_ID: null as string | null,

	/**
	 * Testing aid: list every curriculum in the registry in the goal source bar instead of
	 * only the ones the user's active schools are configured for. Lets you reach a
	 * curriculum without belonging to (or reactivating) a school that uses it.
	 * Off unless VITE_SHOW_ALL_CURRICULA is explicitly "true".
	 */
	// @ts-ignore
	SHOW_ALL_CURRICULA: import.meta.env.VITE_SHOW_ALL_CURRICULA === 'true',

	MAX_FILE_SIZE_MB: 50.00,
	TRIAL_EXPIRATION_WARNING_DAYS: 60,

	OAUTH: {
		// @ts-ignore
		client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,

		// @ts-ignore
		redirect_uri: import.meta.env.VITE_OAUTH_REDIRECT_URI || (window.location.protocol + '//' + window.location.host + '/'),

		// @ts-ignore
		authorization_endpoint: import.meta.env.VITE_OAUTH_AUTHORIZATION_URI || (VITE_API_HOST + '/oauth/authorize'),

		// @ts-ignore
		token_endpoint: import.meta.env.VITE_OAUTH_TOKEN_URI || (VITE_API_HOST + '/oauth/token'),

		requested_scopes: 'full',
	},

	GOOGLE: {
		// @ts-ignore
		client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,

		// @ts-ignore
		developer_key: import.meta.env.VITE_GOOGLE_DEVELOPER_KEY,
	},

	AZURE: {

		// @ts-ignore
		client_id: import.meta.env.VITE_AZURE_CLIENT_ID,

	},

}
